import { merge } from 'editor/core/highcharts-editor';
import { cloneDeep, get, isFunction } from 'lodash';
import { useSelector } from 'react-redux';
import { getFilteredValue } from 'shared/widgets/helpers/WidgetHelper';

export const parseCustomizeOptions = (CustomizeOptions) => {
  const { editorConfig, isMap, chart } = useSelector((state) => state.chartEditorPage);
  let { templateMeta, themeOptions, customizedOptions, aggregatedOptions } = useSelector(
    (state) => state.projectConfig
  );
  const { templateUsed, type } = useSelector((state) => state.layoutEditorPage);

  const getFilterValue = (properties) => {
    const val = getFilteredValue(properties, chart, 0);
    if (properties.filteredBy && isFunction(properties.filteredBy)) {
      return val;
    }
    return get(aggregatedOptions, val);
  };

  let customizeOptions = cloneDeep(CustomizeOptions);

  if (type !== 'chart') {
    aggregatedOptions = merge(cloneDeep(themeOptions.options), cloneDeep(customizedOptions));
  }
  const aggregated =
    type === 'chart' && (chart?.options || chart?.usersOptions)
      ? cloneDeep(chart.options ? chart.options : chart.usersOptions)
      : cloneDeep(aggregatedOptions ?? {});

  Object.keys(customizeOptions || {}).forEach((key) => {
    const option = (customizeOptions || {})[key];
    const disabled = option.every((opt) => opt.mapDisabled && isMap);
    if (disabled) {
      delete (customizeOptions || {})[key];
      return;
    }

    if (option.relevantTo && option.relevantTo.indexOf(templateUsed) === -1) {
      delete (customizeOptions || {})[key];
      return;
    }

    (customizeOptions || {})[key] = option.filter((section) => {
      const isDisabled = (isMap && section.mapDisabled) || (!isMap && section.chartType === 'Map');
      if (isDisabled) return false;

      section.options = section.options.filter((properties) => {
        if ((properties.mapDisabled && isMap) || (!isMap && properties.chartType === 'Map')) return false;
        if (properties.hidden) return false;
        if (
          type === 'chart' &&
          properties.id &&
          editorConfig.customizer &&
          !editorConfig.customizer.availableSettings.includes(properties.id) &&
          properties.type !== 'separator'
        ) {
          return false;
        }

        if (properties.blacklist) {
          let canRender = false;

          if (isFunction(properties.blacklist)) canRender = properties.blacklist(aggregated);
          else canRender = !properties.blacklist.includes(getFilterValue(properties));
          if (!canRender) return false;
        }

        if (properties.subType) {
          let canRender = false;
          canRender = properties.subType.includes(getFilterValue(properties));
          if (!canRender) return false;
        }

        if (isMap && properties.templateType && !properties.templateType?.includes(templateMeta?.[0]?.templateTitle)) {
          return false;
        }

        if (properties.layoutType && properties.layoutType.indexOf(templateUsed) === -1) {
          return false;
        }

        return true;
      });

      return section.options.length > 0;
    });
    if (!(customizeOptions || {})[key].length) delete (customizeOptions || {})[key];
  });

  return customizeOptions;
};
